import axios from 'axios';

const BASE_URL = 'https://api-devo-14.locus-api.com/v1';

const API_URLS = {
    generateJWT: 'client/embedded-login-poc/personnel-master/bob/generate-jwt'
};

const clientSecret = 'c76e3145-fd11-4a54-af4a-eb6e82c0ff47';

const instance = axios.create({
    baseURL: BASE_URL
});

const login = ({ personnel: username, password }) =>
    instance.post(
        API_URLS.generateJWT,
        {
            clientSecret
        },
        {
            auth: {
                username,
                password
            }
        }
    );

export { login as loginAPI };

export default instance;
